/**
 * Format order ID for display as H2A + YYYY + 8-digit counter (15 chars total).
 * If already in the correct format, returns as-is.
 * If a plain numeric/string ID is provided, constructs the display ID using the
 * provided date/year (falls back to current year) and the last 8 digits of the ID.
 *
 * @param {string|number} orderId - The source order identifier
 * @param {object} [opts]
 * @param {string|Date} [opts.date] - A date (created_at/assigned_at) to derive the year
 * @param {number} [opts.year] - Explicit year override
 * @returns {string}
 */
const formatOrderId = (orderId, opts = {}) => {
  if (!orderId) return 'N/A';

  const clean = String(orderId).trim();

  // If already looks like H2AYYYY######## (starts with H2A and length 15), return as-is
  if (/^H2A\d{4}\d{8}$/.test(clean)) return clean;

  // Determine year from opts.date or opts.year or fallback to current year
  let year = opts.year;
  if (!year) {
    const d = opts.date ? new Date(opts.date) : new Date();
    if (!isNaN(d.getTime())) year = d.getFullYear();
    else year = new Date().getFullYear();
  }

  // Prefer trailing digits as the counter to avoid including digits from prefixes (e.g., years)
  const trailingMatch = clean.match(/(\d+)$/);
  const trailingDigits = trailingMatch ? trailingMatch[1] : '';
  const digitsOnly = trailingDigits || clean.replace(/\D+/g, '');
  const counter8 = (digitsOnly || '0').slice(-8).padStart(8, '0');

  const display = `H2A${year}${counter8}`;
  return display;
};

export default formatOrderId;
